// Strips a leading "Agent ", "agent-", "agent_" prefix from any display string.
const STRIP = /^agent[-_\s]?/i;
const strip = (s) => s.replace(STRIP, "").trim() || s;

// Returns the best human-readable display name for an agent/employee object,
// with the "agent" prefix removed from both the name field and agentId fallback.
export function displayName(agent) {
  if (!agent) return "";
  if (typeof agent === "string") return strip(agent);
  const name = agent.name || agent.details?.name;
  if (name) return strip(name);
  const id = agent.agentId || "";
  return strip(id) || id;
}
